import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function OurEventsSection({ ImageUrls = [], VideoUrls = [] }) {
  // example image data (replace with ImageUrls if you want)
  const imageData = [
    {
      src:
        "https://static.wixstatic.com/media/04481b_e89953016ff04e098e577b2a57db0734~mv2.png/v1/fill/w_520,h_520,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/04481b_e89953016ff04e098e577b2a57db0734~mv2.png",
      alt: "wedding",
      text: "WEDDING",
      navPath: "#",
    },
    {
      src:
        "https://danceparties.biz/wp-content/uploads/2020/05/Colour-edited-1-480x400.jpg",
      alt: "birthday",
      text: "BIRTHDAY",
      navPath: "#",
    },
    {
      src:
        "https://attdstudio.com/wp-content/uploads/2024/09/HIP-HOP-768x614.jpg",
      alt: "surprise",
      text: "SURPRISE",
      navPath: "#",
    },
    {
      src:
        "https://topdancefloor.com/wp-content/uploads/2023/06/LED-dance-floor-for-party-1.jpg",
      alt: "private party",
      text: "PRIVATE PARTY",
      navPath: "#",
    },
    {
      src:
        "https://whataftercollege.com/wp-content/uploads/2019/03/Cover-image-4-1024x535.jpg",
      alt: "collage event",
      text: "COLLEGE EVENT",
      navPath: "#",
    },
  ];

  const containerRef = useRef(null);
  const imageCardRefs = useRef([]);

  useEffect(() => {
    const container = containerRef.current;
    const cards = imageCardRefs.current.filter(Boolean);

    // entrance animation for cards with ScrollTrigger (scoped)
    const ctx = gsap.context(() => {
      gsap.fromTo(
        cards,
        { opacity: 0, y: 40, scale: 0.98 },
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.7,
          ease: "power3.out",
          stagger: 0.12,
          scrollTrigger: {
            trigger: container,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        }
      );
    }, containerRef);

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <>
      <style jsx>{`
        .section-wrapper {
          background: linear-gradient(180deg, rgb(26, 24, 24) 0%);
          padding: 20px 20px 100px 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        .section-heading {
          color: #fff;
          font-family: "Impact", "Arial Black", sans-serif;
          font-size: 3rem;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 42px;
          text-align: center;
          z-index: 2;
          position: relative;
        }

        .menu-section-container {
          display: flex;
          justify-content: center;
          align-items: stretch;
          gap: 20px;
          flex-wrap: wrap;
          width: 100%;
          max-width: 1400px;
          z-index: 2;
          position: relative;
        }

        /* base card */
        .Classs {
          position: relative;
          width: calc(33.333% - 20px);
          min-width: 200px;
          max-width: 250px;
          height: 300px;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.28s ease, box-shadow 0.28s ease;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;
          text-align: left;
          border-radius: 8px;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
          text-decoration: none;
          background: linear-gradient(180deg, rgba(0,0,0,0.25), rgba(0,0,0,0.45));
        }

        .Classs:hover {
          transform: translateY(-8px) scale(1.01);
          box-shadow: 0 14px 30px rgba(0, 0, 0, 0.45);
        }

        .Classs img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: brightness(0.55) saturate(1.05);
          transition: filter 0.35s ease;
          position: absolute;
          top: 0;
          left: 0;
        }

        .Classs:hover img {
          filter: brightness(1) saturate(1.05);
        }

        .star-icon {
          position: absolute;
          top: 14px;
          right: 14px;
          color: #ffd966;
          font-size: 28px;
          z-index: 3;
          pointer-events: none;
          text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
        }

        .image-text {
          position: relative;
          color: white;
          font-family: "Impact", "Arial Black", sans-serif;
          font-size: 1.1rem;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          margin-bottom: 16px;
          margin-left: 16px;
          z-index: 1;
          pointer-events: none;
          text-shadow: 0 4px 18px rgba(0, 0, 0, 0.6);
          padding: 6px 10px;
          border-radius: 6px;
          background: rgba(0, 0, 0, 0.35);
        }

        

        /* Mobile responsiveness */
        @media (max-width: 1024px) {
          .Classs {
            width: calc(50% - 20px);
          }
        }

        @media (max-width: 768px) {
          .section-heading {
            font-size: 2rem;
            margin-bottom: 24px;
          }

          .menu-section-container {
            padding: 0 10px;
          }

          .Classs {
            width: 100%;
            max-width: none;
            height: 240px;
          }

          .image-text {
            font-size: 0.95rem;
            margin-left: 12px;
            margin-bottom: 12px;
          }
        }
      `}</style>

      <div className="section-wrapper">
        <h2 className="section-heading">Our Events</h2>

        <div className="menu-section-container" ref={containerRef}>
          {imageData.map((item, index) => {
            const cardClass = `Classs`;
            return (
              <a
                href={item.navPath}
                key={index}
                className={cardClass}
                ref={(el) => (imageCardRefs.current[index] = el)}
                aria-label={item.text}
              >
                <img src={item.src} alt={item.alt || item.text} />
                <span className="star-icon" aria-hidden>
                  ★
                </span>
                <div className="image-text">{item.text}</div>
              </a>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default OurEventsSection;